module.exports = __webpack_public_path__ + "static/img/university.c31b9e6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/detailed/university.svg
// module id = F4pM
// module chunks = 0